import { render, staticRenderFns } from "./HomeCareElderNumber.vue?vue&type=template&id=14850fe0&scoped=true&"
import script from "./HomeCareElderNumber.vue?vue&type=script&lang=js&"
export * from "./HomeCareElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14850fe0",
  null
  
)

export default component.exports